<template>
    <!-- 各门店票核销统计－页面 -->
    <div>
        <content-view class="ticket-count"  v-show="$utils.renderWhen(this,'ticketStatic')">
            <div v-if="shopId == -1" slot="header">
                <a-tabs :defaultActiveKey='key' :animated="false" @change="onTabChange" class="tradeRecord_tab">
                    <a-tab-pane v-for="item in tabListNoTitle" :tab="item.tab" :key="item.key"></a-tab-pane>
                </a-tabs>
            </div>
            <div class="wrap-container-in">
                <div>
                    <a-form :form="form" layout="inline" >
                        当前日期：{{nowDate}}
                        <a-form-item>
                            <a-date-picker @change="startDateChange" :allowClear="false" v-decorator="['startDate',{initialValue: $moment($moment().valueOf() - (89 * 86400000))}]" format="YYYY-MM-DD" />
                        </a-form-item>
                        <span class="mr16">至</span>
                        <a-form-item>
                            <a-date-picker :disabledDate="disabledDate" :allowClear="false" v-decorator="['endDate',{initialValue: $moment()}]" format="YYYY-MM-DD" />
                        </a-form-item>
                        <a-button type="primary" @click="getData">搜索</a-button>
                        <a-button type="primary" @click="exportExcel" :loading="exportLoading">导出</a-button>
                        <span class="text-fail ml16">(时间搜索范围跨度最大为：90天)</span>
                        <div class="float-right">
                            <a-button type="primary" @click="showAddSchemeModal">新增</a-button>
                            <a-button v-if="!canDetele" @click="deleteSellPlan">删除</a-button>
                            <a-button v-if="canDetele" type="primary" @click="cancelDelete">完成</a-button>
                        </div>
                    </a-form>
                </div>
                <a-divider></a-divider>
                <a-spin :spinning="schemeSpinning">
                    <div class="ticket-scheme-raido-container">
                        <div v-for="item in allSchemesList" :key="item.id">
                            <a-radio @click="onClickRideo(item.id)" :checked="item.checked" >{{item.schemeName}}</a-radio> <a-divider v-if="item.id && item.id > 0" type="vertical" /> 
                            <a-popconfirm title="确定要删除该方案吗？" @confirm="delScheme(item.id)" okText="确定" cancelText="取消">
                                <a-icon v-if="canDetele && item.id && item.id > 0" type="close-circle" style="color:#f31d2b" />
                            </a-popconfirm>
                            <a-icon v-if="!canDetele && item.id && item.id > 0" type="edit" @click="getSchemeInfo(item.id)" />
                        </div>
                    </div>
                    <div class="text-center" v-if="allSchemesList.length === 0">暂无方案，请先进行方案新增</div>
                </a-spin>
                <a-divider></a-divider>
                <a-table :loading="loading" :bordered="true" :scroll="{ x: columns.length*90}" :pagination="false" @change="changePage"
                :dataSource="dataSource" :rowKey="(record,index) => index"
                :rowClassName="(record, index) => {
                    let className = 'light-row';
                    if (index % 2 === 1) className = 'dark-row';
                    return className;
                }"
                >
                    <template v-for="(items, index) in columns" v-if="columns.length > 1">
                        <a-table-column :key="index" :data-index="index">
                            <span slot="title" :key="index" @click="toTicketDetail(items, index)" :style="index>0?'color: #1890ff; cursor: pointer;':''">{{items.ticketName}}</span>
                        </a-table-column>
                    </template>
                </a-table>
                <div class="text-center" v-if="columns.length === 1">暂无数据，请先浏览其他页面～</div>
            </div>
            <!-- 新增方案弹窗 -->
            <a-modal 
            :title="schemetitle"
            :confirmLoading="addSchemeLoading"
            :visible="addSchemeVisible"
            :bodyStyle="{padding: 0}"
            @cancel="hideAddSchemeModal"
            @ok="addScheme"
            :width="900"
            >   
                <a-spin :spinning="ticketListSpinning">
                    <a-form :form="addSchemeForm" :selfUpdate="true">
                        <a-tabs defaultActiveKey='0'>
                            <a-tab-pane tab="上架中票券" key="0" :forceRender="true">
                                <a-form-item label="方案名称" :labelCol="{span: 3}" :wrapperCol="{span: 8}">
                                    <a-input v-decorator="['name',{rules: [{required: true, message: '请输入'},{max: 15, message: '最多15个字符'}]}]" placeholder="请输入" />
                                </a-form-item>
                                <a-form-item label="线上票券" :labelCol="{span: 3}" :wrapperCol="{span: 20}">
                                    <div class="select-ticket-container">
                                        <a-checkbox-group :options="ticketList.shelvesTicketList.online" v-decorator="['onlineIds[0]',{initialValue: []}]" />
                                    </div>
                                </a-form-item>
                                <a-form-item label="线下票券" :labelCol="{span: 3}" :wrapperCol="{span: 20}">
                                    <div class="select-ticket-container">
                                        <a-checkbox-group :options="ticketList.shelvesTicketList.offline" v-decorator="['offlineIds[0]',{initialValue: []}]" />
                                    </div>
                                </a-form-item>
                            </a-tab-pane>
                            <a-tab-pane tab="已下架/删除票券" key="1" :forceRender="true">
                                <a-form-item label="线上票券" :labelCol="{span: 3}" :wrapperCol="{span: 20}">
                                    <div class="select-ticket-container">
                                        <a-checkbox-group :options="ticketList.withdrawalTicketList.online" v-decorator="['onlineIds[1]',{initialValue: []}]" />
                                    </div>
                                </a-form-item>
                                <a-form-item label="线下票券" :labelCol="{span: 3}" :wrapperCol="{span: 20}">
                                    <div class="select-ticket-container">
                                        <a-checkbox-group :options="ticketList.withdrawalTicketList.offline" v-decorator="['offlineIds[1]',{initialValue: []}]" />
                                    </div>
                                </a-form-item>
                            </a-tab-pane>
                        </a-tabs>
                    </a-form>
                </a-spin>
            </a-modal>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
export default {
    name: "ticketStatic",
    components: {},
    props: {},
    data() {
        return {
            schemetitle: "", 
            columns: [],
            dataSource: [],
            tabListNoTitle: [],
            pagination: {
                showTotal: total => `共 ${total} 条数据`,
                showSizeChanger: true,
                showQuickJumper: true,
                total: 0,
                current: 1,
                pageSize: 20
            },
            loading: false,
            key: undefined,
            name: '',
            addSchemeVisible: false,
            ticketList:  {
                shelvesTicketList: {
                    offline: [],
                    online: []
                },
                withdrawalTicketList: {
                    offline: [],
                    online: []
                }
            },
            exportLoading: false,
            schemeSpinning: false,
            ticketListSpinning: false,
            addSchemeLoading: false,
            schemeId: undefined,
            activeSchemeId: undefined,
            allSchemesList: [],
            canDetele: false,
            isSchemeEdit: false,
            nowDate: "",
        };
    },
    computed: {
        ...mapGetters(["shopId"])
    },
    filters: {
        ticketIndex(index, ticketIndex, columns) {
            var length = 0;
            for (let i = 0; i < ticketIndex; i++) {
                if (typeof columns[i].ticketPrivilegeName == "object") {
                    length += (columns[i].ticketPrivilegeName.length || 1);
                } else {
                    length += 1;
                }
            }
            return length + index;
        },
        ticketPrive(index, columns) {
            var length = 0;
            for (let i = 0; i < index; i++) {
                if (typeof columns[i].ticketPrivilegeName == "object") {
                    length += (columns[i].ticketPrivilegeName.length || 1);
                } else {
                    length += 1;
                }
            }
            return length;
        }
    },
    watch: {
        key(val) {
            this.name = this.tabListNoTitle.filter(item => item.key === e)[0].tab
            this.getTicketList();
            this.queryAllSchemes();
        }
    },
    methods: {
        toTicketDetail(item, index) {
            if (index == 0) {
                return;
            }
            this.form.validateFields((err, values) => {
                let dateLine = `${this.$moment(values.startDate).format('YYYY-MM-DD')} ~ ${this.$moment(values.endDate).format('YYYY-MM-DD')}`
                this.$router.push({name: "ticketCountDetail", query: {lineType: item.lineType, dateLine, id: item.ticketId, type: this.schemeId, shopId: this.key}})
            })
        },
        /**
         * @startDateChange 开始日期变动联动结束日期
         */
        startDateChange(date) {
            this.form.setFieldsValue({'endDate': this.$moment(date.valueOf() + (89 * 86400000))});
        },
        /**
         * @disabledDate 结束日期的禁用
         */
        disabledDate(date) {
            let startDate = this.form.getFieldValue('startDate');
            return !(date.valueOf() >= startDate.valueOf() && ((date.valueOf() - startDate.valueOf()) < (90 * 86400000)))
        },
        /**
         * @showAddSchemeModal 显示新增方案弹窗
         */
        showAddSchemeModal() {
            this.schemetitle = "新增方案";
            this.addSchemeVisible = true;
            this.isSchemeEdit = false;
        },
        /**
         * @hideAddSchemeModal 隐藏新增方案弹窗
         */
        hideAddSchemeModal() {
            this.addSchemeForm.setFieldsValue({
                name: undefined,
                onlineIds: [[], []],
                offlineIds: [[], []]
            });
            this.addSchemeVisible = false;
        },
        changePage(page) {
            this.pagination.pageSize = page.pageSize
            this.pagination.current = page.current
            this.getData()
        },
        getShopList() {
            if(!this.shopId) return
            this.$api.totalPlatform.selectList()
            .then(res => {
                this.tabListNoTitle = []
                if(this.shopId == -1) {
                    res.map(item => {
                        this.tabListNoTitle.push({
                            key: item.id,
                            tab: item.name
                        })
                    })
                }else {
                    this.tabListNoTitle.push({
                        key: this.shopId,
                        tab: res.filter(item => item.id == this.shopId)[0].name
                    })
                }
                
                this.key = String(this.tabListNoTitle[0].key);
                this.name = String(this.tabListNoTitle[0].tab);
                this.getTicketList();
                this.queryAllSchemes();
            });
        },
        /**
         * @getTicketList 门店线上线下票
         */
        getTicketList() {
            this.ticketListSpinning = true;
            this.$api.statement.queryTicketByShopId({
                params: {
                    shopId: this.key
                }
            }).then(res => {
                res.shelvesTicketList.online.forEach(item => {
                    item.label = item.name;
                    item.value = item.id;
                });
                res.shelvesTicketList.offline.forEach(item => {
                    item.label = item.name;
                    item.value = item.id;
                });
                res.withdrawalTicketList.online.forEach(item => {
                    item.label = item.name;
                    item.value = item.id;
                });
                res.withdrawalTicketList.offline.forEach(item => {
                    item.label = item.name;
                    item.value = item.id;
                });
                this.ticketList = res;
                this.ticketListSpinning = false;
            });
        },
        /**
         * @queryAllSchemes 查询方案
         */
        queryAllSchemes() {
            this.schemeSpinning = true;
            this.$api.statement.getTicketScheme({
                params: {
                    shopId: this.key
                }
            }).then(res => {
                res.forEach(item => {
                    item.checked = false;
                })
                this.allSchemesList = [
                    {
                        checked: false,
                        deleteFlag: 0,
                        id: -3,
                        schemeName: "核销其它门店票券统计",
                        shopId: this.shopId,
                    }, 
                    {
                        checked: false,
                        deleteFlag: 0,
                        id: -2,
                        schemeName: "其它门店跨店核销统计",
                        shopId: this.shopId,
                    },
                    ...res
                ];
                if (res.length >= 1) {
                    res[0].checked = true;
                    this.schemeId = res[0].id;
                } else {
                    this.allSchemesList[0].checked = true;
                    this.schemeId = -3;
                }
                this.schemeSpinning = false;
                this.getData();
            }).catch( err => {
                this.schemeSpinning = false;
            });
        },
        /**
         * @getDate 获取报表数据
         */
        getData() {
            this.form.validateFields((errors,values) => {
                if (errors) return;
                this.loading = true;
                if (this.schemeId > 0) {
                    this.getSchemeData(values);
                } else if (this.schemeId == -2) {
                    this.getCrossData(values)
                } else if (this.schemeId == -3) {
                    this.verifyOtherShop(values)
                } else {
                    this.loading = false;
                }
            });
        },
        //其他门店 -3
        verifyOtherShop(values) {
            this.$api.statement.verifyOtherShop({body:{
                verifyShopId: this.key,
                startTime: values.startDate.format('YYYY-MM-DD'),
                endTime : values.endDate.format('YYYY-MM-DD'),
            }}).then(res => {
                this.loading = false
                this.columns = [{
                    ticketName: "票券名称",
                    register: "核销结算统计",
                    ticketPrivilegeName: [],
                    width: 80,
                    key: 0,
                } ,...res.tableTitle];
                this.dataSource = []
                if (!res.tableTitle.length) {
                    return;
                }
                let verifyAmountList = res.verifyAmountList.reduce((total, item) => {
                    return total + item * 1;
                }, 0);
                let verifyCountList = res.verifyCountList.reduce((total, item) => {
                    return total + item * 1;
                }, 0);
                res.verifyCountList.unshift(`核销次数合计(${verifyCountList})`);
                res.verifyAmountList.unshift(`核销金额统计(${verifyAmountList.toFixed(2)})`);
                this.dataSource.unshift({...res.verifyCountList}, {...res.verifyAmountList});
                for (const i in res.data) {
                    this.dataSource.push({...res.data[i]})
                };
            }).catch( err => {
                this.loading = false;
            })
        },
        //其他门店跨店
        getCrossData(values) {
            const crossVerify = this.$api.statement.crossVerify({body:{
                shopId: this.key,
                schemeId: -1,
                startTime: values.startDate.format('YYYY-MM-DD'),
                endTime: values.endDate.format('YYYY-MM-DD'),
            }});
            const getNormalTitle = this.$api.statement.getOtherTitle({body:{
                schemeId: this.schemeId > 0 ? this.schemeId : -1,
                shopId: this.key,
                withPrivilege: true,
                startTime: values.startDate.format('YYYY-MM-DD'),
                endTime: values.endDate.format('YYYY-MM-DD'),
                isCross: true,
            }});
            Promise.all([crossVerify, getNormalTitle]).then(([data, title]) => {
                this.loading = false
                this.columns = [{
                    ticketName: "票券名称",
                    register: "门店名称",
                    ticketPrivilegeName: [],
                    width: 80,
                    key: 0,
                }, ...title];
                this.dataSource = [];
                data.forEach(el => {
                    let ticketLists = {
                        0: `${el.shopName}(${el.totalVerifyNum}:${el.totalVerifyAmount.toFixed(2)})`,
                    };
                    el.ticketVoList.forEach( (item,index) => {
                        ticketLists = {
                            ...ticketLists,
                            [index + 1]: `${item.verifyNum}(${item.verifyAmount.toFixed(2)})`
                        };
                    })
                    this.dataSource.push(ticketLists)
                })
            }).catch( err => {
                this.loading = false;
            })
        },
        //核销
        getSchemeData(values) {
            this.$api.statement.verifyAmountSettlement({body:{
                shopId: this.key,
                schemeId: this.schemeId,
                startTime: values.startDate.format('YYYY-MM-DD'),
                endTime: values.endDate.format('YYYY-MM-DD'),
            }}).then( data => {
                this.loading = false
                this.columns = [{
                    ticketName: "票券名称",
                    register: "核销结算统计",
                    ticketPrivilegeName: [],
                    width: 80,
                    key: 0,
                },...data.header];
                // if (!data.data.length) {
                //     return;
                // }
                // let verifyAmountList = data.verifyAmountList.reduce((total, item) => {
                //     return total*1 + item*1;
                // }, 0);                
                // let verifyCountList = data.verifyCountList.reduce((total, item) => {
                //     return total*1 + item*1;
                // }, 0);
                data.verifyCountList.unshift(`核销次数合计(${data.verifyCountTotal})`);
                data.verifyAmountList.unshift(`核销金额统计(${data.verifyAmountTotal})`);
                this.dataSource = [
                    {...data.verifyCountList}, 
                    {...data.verifyAmountList},
                ];
                for (const i in data.data) {
                    this.dataSource.push({...data.data[i]})
                };
            }).catch( err => {
                this.loading = false;
            })
        },
        // 导出excel
        exportExcel() {
            this.form.validateFields((errors,values) => {
                if (errors) return;
                if (this.schemeId == -2) {
                    var exportExcels = this.$api.statement.getExtraExport({
                        body: {
                            schemeId: -1,
                            shopId: this.key,
                            startTime: values.startDate.format('YYYY-MM-DD'),
                            endTime: values.endDate.format('YYYY-MM-DD'),
                        }
                    },
                    {
                        responseType: "blob"
                    })
                } else if (this.schemeId == -3) {
                    var exportExcels = this.$api.statement.exportVerifyOtherShopExcel({
                        body: {
                            // schemeId: -1,
                            verifyShopId: this.key,
                            startTime: values.startDate.format('YYYY-MM-DD'),
                            endTime: values.endDate.format('YYYY-MM-DD'),
                        }
                    },
                    {
                        responseType: "blob"
                    })
                } else {
                    var exportExcels = this.$api.statement.getTicketExport({
                        body: {
                            schemeId: this.schemeId,
                            shopId: this.key,
                            startTime: values.startDate.format('YYYY-MM-DD'),
                            endTime: values.endDate.format('YYYY-MM-DD'),
                        }
                    },
                    {
                        responseType: "blob"
                    })
                }
                this.exportLoading = true;
                exportExcels.then(res => {
                    let a = document.createElement("a");
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    this.downloadUrl = window.URL.createObjectURL(blob);
                    let name = this.name + '-' + this.$moment().format('YYYY/MM/DD') + '.xls'
                    a.setAttribute("href", this.downloadUrl);
                    var reportName = decodeURI(name);
                    a.setAttribute("download", reportName);
                    a.click();
                    this.exportLoading = false
                }).catch(err => {
                    this.exportLoading = false
                })
            })
        },
        onTabChange(e) {
            this.key = e;
            this.name = this.tabListNoTitle.filter(item => item.key === e)[0].tab
            this.getTicketList();
            this.queryAllSchemes();
        },
        /**
         * @addScheme 新增/编辑方案
         */
        addScheme(){
            this.addSchemeForm.validateFields((errors, values) => {
                if(errors) {
                    return false;
                }
                if (!values.onlineIds.flat().length && !values.offlineIds.flat().length) {
                    this.$message.error('票券不能为空');
                    return false;
                }
                this.addSchemeLoading = true;
                let reqData = {
                    shopId: this.key,
                    schemeName: values.name,
                    onlineIds: values.onlineIds.flat(),
                    offlineIds: values.offlineIds.flat(),
                };
                if (this.isSchemeEdit) {
                    reqData.schemeId = this.activeSchemeId;
                }
                this.$api.statement[this.isSchemeEdit ? 'editTicketScheme' : 'addNewTicketScheme'](
                    {
                        body: reqData
                    }
                ).then(res => {
                    this.addSchemeLoading = false;
                    this.$message.success('操作成功！');
                    this.hideAddSchemeModal();
                    this.queryAllSchemes();
                }).catch(error => {
                    this.addSchemeLoading = false;
                });
            });
        },
        /**
         * @delScheme 删除方案
         */
        delScheme(schemeId){
            this.$api.statement.delTicketScheme({
                params: {
                    schemeId
                }
            }).then(res => {
                this.$message.success('删除成功！');
                this.queryAllSchemes();
            });
        },
        /**
         * @getSchemeInfo 获取方案详情
         */
        getSchemeInfo(schemeId) {
            this.activeSchemeId = schemeId;
            this.addSchemeVisible = true;
            this.ticketListSpinning = true;
            this.isSchemeEdit = true;
            this.schemetitle = "编辑方案";
            this.$api.statement.getTicketSchemeDetail({
                params: {
                    schemeId
                }
            }).then(res => {
                /**
                 * @offlineIdsArray 详情结果票券id数组
                 * @onlineIdsArray 详情结果票券id数组
                 * @sOnlineTickets 正在售卖的线上票列表
                 * @sOfflineTickets 正在售卖的线下票列表
                 * @wOnlineTickets 已下架/删除的线上票列表
                 * @wOfflineTickets 已下架/删除的线下票列表
                 * @sOnlineIds 方案详情正在售卖的线上票券id
                 * @sOfflineIds 方案详情正在售卖的线下票券id
                 * @wOnlineIds 方案详情已下架/删除的线上票券id
                 * @wOfflineIds 方案详情已下架/删除的线下票券id
                 */
                let onlineIdsArray = res.onlineId.split(',');
                let offlineIdsArray = res.offlineId.split(',');
                let sOnlineTickets = this.ticketList.shelvesTicketList.online;
                let sOfflineTickets = this.ticketList.shelvesTicketList.offline;
                let wOnlineTickets = this.ticketList.withdrawalTicketList.online;
                let wOfflineTickets = this.ticketList.withdrawalTicketList.offline;
                let sOnlineIds = [];
                let sOfflineIds = [];
                let wOnlineIds = [];
                let wOfflineIds = [];
                // 线上在售票券筛选
                sOnlineTickets.forEach(items => {
                    let findRes = onlineIdsArray.find(item => Number(item) === items.id);
                    if (typeof findRes !== 'undefined') {
                        sOnlineIds.push(Number(findRes));
                    }
                });
                // 线上下架/删除的票券筛选
                wOnlineTickets.forEach(items => {
                    let findRes = onlineIdsArray.find(item => Number(item) === items.id);
                    if (typeof findRes !== 'undefined') {
                        wOnlineIds.push(Number(findRes));
                    }
                });
                // 线下在售票券筛选
                sOfflineTickets.forEach(items => {
                    let findRes = offlineIdsArray.find(item => Number(item) === items.id);
                    if (typeof findRes !== 'undefined') {
                        sOfflineIds.push(Number(findRes));
                    }
                });
                // 线下下架/删除的票券筛选
                wOfflineTickets.forEach(items => {
                    let findRes = offlineIdsArray.find(item => Number(item) === items.id);
                    if (typeof findRes !== 'undefined') {
                        wOfflineIds.push(Number(findRes));
                    }
                });
                setTimeout(() => {
                    this.ticketListSpinning = false;
                    this.addSchemeForm.setFieldsValue({
                        name: res.schemeName,
                        onlineIds: [sOnlineIds, wOnlineIds],
                        offlineIds: [sOfflineIds, wOfflineIds]
                    });
                },300)
            });
        },
        /**
         * @deleteSellPlan 删除按钮
         */
        deleteSellPlan() {
            this.canDetele = true;
        },
        /**
         * @cancelDelete 删除完成按钮
         */
        cancelDelete() {
            this.canDetele = false;
            this.queryAllSchemes();
        },
        /**
         * @onClickRideo 方案radio的点击事件
         */
        onClickRideo(id) {
            if (this.loading) {
                return;
            }
            this.schemeId = id
            this.getData()
            this.allSchemesList.forEach(item => {
                item.checked = false
                if(item.id === id) {
                    item.checked = true
                }
            })
        }
    },
    beforeCreate() {
        this.form = this.$form.createForm(this);
        this.addSchemeForm = this.$form.createForm(this);
    },
    created() {},
    mounted() {
        this.getShopList();
        this.nowDate = this.$moment(new Date()).format("YYYY.MM.DD")
    },
    watch: {
        'shopId'() {
            this.getShopList()
        }
    }
};
</script>
<style lang="scss">
.ticket-count {
    tr{
        th:first-child {
            width: 150px;
        }
    }
    &-tablebox {
        min-width: 150px !important;
        position: relative;
        background: linear-gradient(
            to top right,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0) calc(50% - .5px),
            rgba(0, 0, 0, 0.5) 50%,
            rgba(0, 0, 0, 0) calc(50% + .5px),
            rgba(0, 0, 0, 0) 100%
        );
        span {
            font-size: 12px;
            display: inline-block;
            width: 100%;
            height: 50%;
            &:first-child {
                text-align: right;
            }
            &:last-child {
                text-align: left;
            }
        }
    }
    .wrap-title {
        padding-bottom: 8px;
    }
    .wrap-header {
        padding-bottom: 0;
    }
    .wrap-container-in {
        padding: 16px;
    }
    .ant-table-thead > tr > th, .ant-table-tbody > tr > td {
        padding: 6px;
    }
    .dark-row {
        background-color: #f9f9f9;
    }
    table td,
    table th {
        text-align: center;
    }
    .ant-table-column-sorter {
        display: none;
    }
    .ticket-scheme-raido-container {
        >div {
            display: inline-block;
            margin: 0 8px 8px 0;
            padding: 4px 12px;
            border: 1px solid #e9e9e9;
            border-radius: 4px;
            &:hover {
                border: 1px solid #ff9646;
            }
        }
    }
}
.select-ticket-container {
    max-height: 200px;
    overflow-x: hidden;
    overflow-y: scroll;
}
</style>